<template>
  <div class="gradient-color">
    <span class="gc-label">渐变色</span>
    <span class="gc-item gc-none" @click="onColorClick()">无</span>
    <span class="gc-item" v-for="(item, index) in gradient_list" :key="index" :style="renderStyle(item)" @click="onColorClick(item)"></span>
  </div>
</template>
<script>
    import {gradient_list} from "../../../../../const";
    export default {
        data() {
            return {
                gradient_list
            };
        },
        methods: {
            onColorClick(list) {
                this.$emit('onGradientColorChange', list)
            },
            renderStyle(list) {
              return `background: linear-gradient(to right, ${list[0]}, ${list[1]})`;
            }
        }
    }
</script>
<style lang="scss">
  .gradient-color{
    margin: 7px 0px;
    .gc-item,.gc-label{
      width: 20px;
      height: 20px;
      display: inline-block;
      margin: 3px;
    }
    .gc-label{
      width: 51px;
      vertical-align: top;
      font-size: 14px;
    }
    .gc-none{
      vertical-align: top;
      box-shadow: 0 0 11px -2px #c0ccda;
      text-align: center;
      color: gray;
      &:hover{
        color: #000000;
      }
    }
    .gc-item{
      border-radius: 2px;
      -webkit-background-clip: text;
      cursor: pointer;
      &:hover{
        box-shadow: 0 0 3px 2px #409eff;
      }
    }
  }
</style>